import ThreeDotsClaim from "./threeDotsClaim";
import { ThreeDotsClaimHistory } from "./options/threeDotsClaimHistory";
import { ThreeDotsClaimAudit } from "./options/threeDotsClaimAudit";
import { ThreeDotsClaimImage } from "./options/threeDotsClaimImage";
import { ThreeDotsClaimCancel } from "./options/threeDotsClaimCancel";
import { ThreeDotsClaimReturn } from "./options/threeDotsClaimReturn";
import { ThreeDotsClaimTracking } from "./options/threeDotsClaimTracking";
import { ThreeDotsClaimRequote } from "./options/threeDotsClaimRequote";
import { ThreeDotsClaimGenerateProcurement } from "./options/threeDotsClaimGenerateProcurement";
import { ThreeDotsClaimDirectAssign } from "./options/threeDotsClaimDirectAssign";
import ThreeDotsClaimReassignPartSearchClaim from "./options/threeDotsClaimReassignPartSearchClaim";
import { ThreeDotsClaimSendUpdates } from "@/main/screens/claim/searchClaim/gridSearchClaim/rowSearchClaim/collapseSearchClaim/headerCollapseSearchClaim/threeDotsClaim/options/threeDotsClaimSendUpdates";
import { ThreeDotsClaimPrintSupplierPartsReport } from "./options/threeDotsClaimPrintSupplierPartsReport";

export default {
	Root: ThreeDotsClaim,
	OptionHistory: ThreeDotsClaimHistory,
	OptionAudit: ThreeDotsClaimAudit,
	OptionImage: ThreeDotsClaimImage,
	OptionCancel: ThreeDotsClaimCancel,
	OptionReturn: ThreeDotsClaimReturn,
	OptionTracking: ThreeDotsClaimTracking,
	OptionRequote: ThreeDotsClaimRequote,
	OptionGenerateProcurement: ThreeDotsClaimGenerateProcurement,
	OptionDirectAssign: ThreeDotsClaimDirectAssign,
	ClaimReassignPartSearchClaim: ThreeDotsClaimReassignPartSearchClaim,
	OptionsSendUpdates: ThreeDotsClaimSendUpdates,
	OptionPrintSupplierPartsReport: ThreeDotsClaimPrintSupplierPartsReport,
};
